module.exports = __webpack_public_path__ + "img/pay-item-4.bc1b6e96.png";